import * as React from "react";
import { OldProgressBarQuestionnaireSectionUnconnected } from "@teamprevent/common/questionnaires/components/OldProgressBarQuestionnaireSection";
import { getQuestionConfig } from "@teamprevent/common/questionnaires/questionnaireConfig";

import { connect } from "react-redux";
import { mapDispatchToQuestionnaireSectionProps, makeMapStateToQuestionnaireSectionProps } from "@teamprevent/common/questionnaires/mappers";
import { YesNoWithFollowUpQuestion } from "@teamprevent/common/questionnaires/components/questions/YesNoWithFollowUpQuestion";

import * as questionIds from "../questions/questionIds";
import { HealthSurveillanceSectionProps } from "../models";
import { sections } from "../questionnaire";

// eslint-disable-next-line max-len
const HealthSurveillanceFoodHandlerSectionUnconnected: React.FunctionComponent<HealthSurveillanceSectionProps> = (props: HealthSurveillanceSectionProps) => {
    return (
        <OldProgressBarQuestionnaireSectionUnconnected
            {...props}
            {...sections.FoodHandler}
        >
            <h4>Have you ever had any of the following?</h4>
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.EverHadTyphoidFever),
                    getQuestionConfig(props.questionConfigs, questionIds.EverHadTyphoidFeverFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.EverHadBowelDisorders),
                    getQuestionConfig(props.questionConfigs, questionIds.EverHadBowelDisordersFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.EverHadTuberculosis),
                    getQuestionConfig(props.questionConfigs, questionIds.EverHadTuberculosisFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.EverHadAsthmaOrChestInfection),
                    getQuestionConfig(props.questionConfigs, questionIds.EverHadAsthmaOrChestInfectionFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.EverHadRecurringSkinDisorders),
                    getQuestionConfig(props.questionConfigs, questionIds.EverHadRecurringSkinDisordersFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.EverHadAllergicReactions),
                    getQuestionConfig(props.questionConfigs, questionIds.EverHadAllergicReactionsFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.EverHadBackNeckArmWristProblems),
                    getQuestionConfig(props.questionConfigs, questionIds.EverHadBackNeckArmWristProblemsFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.EverHadDeafnessDefectiveVision),
                    getQuestionConfig(props.questionConfigs, questionIds.EverHadDeafnessDefectiveVisionFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.EverHadBlackoutsDizzySpells),
                    getQuestionConfig(props.questionConfigs, questionIds.EverHadBlackoutsDizzySpellsFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            <h4>Within the last two weeks have you suffered from any of the following:</h4>
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.SkinInfectionWithinLastTwoWeeks),
                    getQuestionConfig(props.questionConfigs, questionIds.SkinInfectionWithinLastTwoWeeksFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.DiarrhoeaVomitingWithinLastTwoWeeks),
                    getQuestionConfig(props.questionConfigs, questionIds.DiarrhoeaVomitingWithinLastTwoWeeksFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.EarEyeGumInfectionWithinLastTwoWeeks),
                    getQuestionConfig(props.questionConfigs, questionIds.EarEyeGumInfectionWithinLastTwoWeeksFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.ContactWithTyphoidWithinLastTwoWeeks),
                    getQuestionConfig(props.questionConfigs, questionIds.ContactWithTyphoidWithinLastTwoWeeksFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            <h4>Additional Questions</h4>
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.TyphoidCarrier),
                    getQuestionConfig(props.questionConfigs, questionIds.TyphoidCarrierFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.DiarrhoeaVommitingLast7Days),
                    getQuestionConfig(props.questionConfigs, questionIds.DiarrhoeaVommitingLast7DaysFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
        </OldProgressBarQuestionnaireSectionUnconnected>
    );
};

// eslint-disable-next-line max-len
export const HealthSurveillanceFoodHandlerSection = connect(makeMapStateToQuestionnaireSectionProps(sections.FoodHandler.id), mapDispatchToQuestionnaireSectionProps)(HealthSurveillanceFoodHandlerSectionUnconnected);
